var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4DataManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h4v16h-4V46zm16 16h4V42h-4v20zm16 0h4V30h-4v32zm16 0h4V23h-4v39zm-40 0h4V46h-4v16zm16 0h4V36h-4v26zm16 0h4V30h-4v32zm-4.7-41H37.23L20.67 36H12v3.91h10.2L38.77 25h9.93L64 12.76V7.64L47.3 21z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Data_management.c6f8331d.svg";
export { SvgA4DataManagement as ReactComponent };